import "./style.css";
import Logo from "../../assets/logo.svg";
import ProfileImag from "../../assets/profile.jpg";

export default function Header() {
  return (
    <header>
      <img className="logo" src={Logo} alt="logo" />
      <div className="container-welcome">
        <img className="profile-img" src={ProfileImag} alt="profile" />
        <strong>Bem vindo, Ryander.</strong>
      </div>
    </header>
  );
}
